
import React, { useContext, useEffect } from 'react';
import { AuthContext } from './AuthProvider';
import { fetchAndGetCSRFToken } from './utils/csrf';

export default function TopNavBar() {
  const { user, logout } = useContext(AuthContext);

  useEffect(() => {
    (async () => {
      try {
        await fetchAndGetCSRFToken();
      } catch (e) {
        // ignore
      }
    })();
  }, []);

  // const handleLogout = async () => {
  //   try {
  //     await ensureCsrf();
  //     await axios.post('/logout/', {}, { withCredentials: true, headers: { 'X-CSRFToken': getCookie('csrftoken') || '' } });
  //   } catch (_) { /* ignore */ }
  const handleLogout = async () => {
    try {
      await fetchAndGetCSRFToken();
      await logout();
      window.location.href = '/login';
    } catch (err) {
      console.error('Logout failed', err);
    }
  };

  return (
    <nav className="w-full bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center shadow-sm">
      <h2 className="text-2xl font-semibold text-gray-800">ApplyWizz - Your Career Solutions Platform</h2>
      <div className="flex flex-col items-end gap-1">
        <span className="text-gray-700 font-medium">{user?.full_name || user?.email || ''}</span>
        <button onClick={handleLogout} className="text-red-600 font-semibold hover:underline">Logout</button>
      </div>
    </nav>
  );
}
